import { useAppDispatch, useAppSelector } from "../../../../reduxToolkit/hooks";
import { setAddModal } from "../../../../reduxToolkit/reducers/bookmarkTabsSlice";
import BookmarkFormModal from "./common/BookmarkFormModal";

// Modal for adding bookmark.
const CreateBookmark = () => {
  const { addModal } = useAppSelector((state) => state.bookmarkTab);
  const dispatch = useAppDispatch();

  return <BookmarkFormModal isOpen={addModal} toggle={() => dispatch(setAddModal())} />;
};

export default CreateBookmark;
